import { newsApi } from '@features/news/api/newsApi'
import { HOME_NEWS_PREVIEW_SIZE } from '@features/news/constants'

/**
 * Превью новостей для главной.
 *
 * @param size - количество загружаемых новостей
 * @returns реактивные данные списка новостей
 */
export const useNewsPreview = async (size = HOME_NEWS_PREVIEW_SIZE) => {
  const { data: news } = await newsApi.getList({
    page: 1,
    size,
  })

  return {
    news,
  }
}
